import React from 'react';
import WaitingRoomPlayer from './WaitingRoomPlayer';
import { WaitingRoomPlayersInterface } from './WaitingRoomPlayersInterface';

function WaitingRoomSixPlayers({players, isHost}: WaitingRoomPlayersInterface) {

    return (
        <div className="playersWrapper">
            <div className="sixPlayersWrapper1">
                <WaitingRoomPlayer name={players[5].name} image={players[5].image}/>
            </div>
            <div className="sixPlayersWrapper2">
                <WaitingRoomPlayer name={players[3].name} image={players[3].image}/>
                <WaitingRoomPlayer name={players[4].name} image={players[4].image}/>
            </div>
            <div className="sixPlayersWrapper3">
                <WaitingRoomPlayer name={players[1].name} image={players[1].image}/>
                <WaitingRoomPlayer name={players[2].name} image={players[2].image}/>
            </div>
            <div className="sixPlayersWrapper4">
                <WaitingRoomPlayer name={players[0].name} image={players[0].image}/>
            </div>
        </div>
    );
};

export default WaitingRoomSixPlayers;